import { SearchCriteriaGroup } from "./searchCriteriaGroup";

export class Sort{
    field:string;
    dir : 'asc' | 'desc';
}

export class Criteria{
    sort : Sort;
    filter: SearchCriteriaGroup[];
}